import React from "react";
import PropTypes from "prop-types";

import Button from "../button/index.js";

import styles from "./styles.module.scss";

const Tags = (props) => {
  return props.tags?.length > 0 ? (
    <div className={styles.tags}>
      {props.layout === "buttons" ? (
        <>
          <h6>Tags</h6>
          {props.tags.map((tag, index) => (
            <Button
              buttonType="button"
              element={props.element}
              key={index}
              label={tag.label}
              size="small"
              to={tag.path}
            />
          ))}
        </>
      ) : (
        <div className={styles.tags}>
          <span className={styles.simplified}>
            {props.tags.map((tag, index) => (
              <span key={index}>
                <props.element to={tag.path}>{tag.label}</props.element>
              </span>
            ))}
          </span>
        </div>
      )}
    </div>
  ) : null;
};

Tags.defaultProps = {
  element: "a",
  layout: "buttons",
  tags: []
};

Tags.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  layout: PropTypes.oneOf(["buttons", "simplified"]),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string
    })
  )
};

export default Tags;
